import { useSelector } from 'react-redux'

import {
  DEFAULT_POST_PAYMENT_FLOW_CONFIG,
  UPSELL_POST_PAYMENT_FLOW_CONFIG,
  UPSELL_POST_PAYMENT_FLOW_CONFIG_ACCOUNT_FIRST,
  WELLNESS_POST_PAYMENT_FLOW_CONFIG,
} from 'post-payment-config'

import {
  selectCurrentVariantCohortToUse,
  selectHasUpsellOffer,
} from 'root-redux/selects/common'

import { useIsUsGeoCohort } from 'hooks/useIsUsGeoCohort'
import { usePostPaymentOrder } from 'hooks/usePostPaymentOrder'

import { Cohort } from 'root-constants'

export const usePostPaymentFlowConfig = () => {
  const cohortToUse = useSelector(selectCurrentVariantCohortToUse)
  const hasUpsellOffer = useSelector(selectHasUpsellOffer)
  const shouldSkipUpsellForUser = useIsUsGeoCohort()
  const { isAccountBeforeUpsellOrder } = usePostPaymentOrder()

  if (
    cohortToUse === Cohort.AP_WLDB_313 ||
    cohortToUse === Cohort.AP_WLDB_QUIZ_313
  ) {
    return WELLNESS_POST_PAYMENT_FLOW_CONFIG
  }

  if (!hasUpsellOffer || shouldSkipUpsellForUser) {
    return DEFAULT_POST_PAYMENT_FLOW_CONFIG
  }

  return isAccountBeforeUpsellOrder
    ? UPSELL_POST_PAYMENT_FLOW_CONFIG_ACCOUNT_FIRST
    : UPSELL_POST_PAYMENT_FLOW_CONFIG
}
